export interface MainContainerProps {
  children: React.ReactNode;
}
const HeaderHeight = '56px';
const FooterHeight = '56px';
export const MainContainer = (props: MainContainerProps) => (
  <div
    style={{
      height: `calc(100vh - ${HeaderHeight} - ${FooterHeight})`,
      overflowY: 'auto',
      maxWidth: '100vw'
    }}>
    {props.children}
  </div>
);
